// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b49a62dc46--wrapper--Q_rZV","button":"b49a62dc46--button--vYDhM","text":"b49a62dc46--text--j0d8v"};